import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Frontend-only invisible boundary marker used by the unified letter editor to
 * map one continuous ProseMirror doc back to the per-section LetterSection rows
 * (LTR-08). It is NEVER part of stored content: letterDocMapping.splitDocToSections
 * excludes boundary nodes, and sanitizeHtml() strips `<div>` anyway, so no
 * `data-section-boundary` can ever land in content_html / content_json.
 *
 * It renders as a `display:none` non-editable div; it exists purely as a
 * document anchor delimiting where one section's body starts.
 */
export const SectionBoundary = Node.create({
  name: 'sectionBoundary',
  group: 'block',
  atom: true, // leaf mapping anchor — no editable content
  selectable: false,
  draggable: false,

  addAttributes() {
    return {
      sectionId: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-section-id'),
        renderHTML: (attrs) =>
          attrs.sectionId ? { 'data-section-id': attrs.sectionId } : {},
      },
      sectionKey: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-section-key'),
        renderHTML: (attrs) =>
          attrs.sectionKey ? { 'data-section-key': attrs.sectionKey } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-section-boundary]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-section-boundary': '',
        contenteditable: 'false',
        'aria-hidden': 'true',
        style: 'display:none',
      }),
    ];
  },
});
